import Line from './chart-line'

export default { Line }
